import styled from "styled-components";
import { useNavigate } from "react-router";

import error from "../../assets/images/error.png";
import { Typography } from "../atoms/Typography";
import { Button } from "../atoms/Button";

/**
 * エラーページ
 */

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: center;
  img {
    margin-top: 80px;
  }
`;

const TitleWrapper = styled.div`
  margin-bottom: 18px;
`;

const SubtitleWrapper = styled.div`
  margin-bottom: 40px;
  width: 100%;
  max-width: 400px;
  height: 38px;
  text-align: center;
`;

const GoBackButtonWrapper = styled.div`
  width: 100%;
  max-width: 400px;
  height: 44px;
  background-color: ${(props) => props.theme.colors.brand};
  border-radius: 6px;
  justify-content: center;
  align-items: center;
`;

export const ErrorPage = () => {
  const navigate = useNavigate();
  return (
    <Container>
      <img src={error} width="300" height="300" alt={"error"} />
      <TitleWrapper>
        <Typography size={6} bold>
          エラーが発生しました
        </Typography>
      </TitleWrapper>
      <SubtitleWrapper>
        <Typography size={2}>管理者にお問い合わせください。</Typography>
      </SubtitleWrapper>
      <GoBackButtonWrapper>
        <Button
          onClick={() => {
            navigate(-1);
          }}
          buttonType="primary"
        >
          <Typography size={2} bold>
            前のページにもどる
          </Typography>
        </Button>
      </GoBackButtonWrapper>
    </Container>
  );
};
